import { render, staticRenderFns } from "./manuscript_draft.vue?vue&type=template&id=bfc7da8c&scoped=true"
import script from "./manuscript_draft.vue?vue&type=script&lang=js"
export * from "./manuscript_draft.vue?vue&type=script&lang=js"
import style0 from "./manuscript_draft.vue?vue&type=style&index=0&id=bfc7da8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc7da8c",
  null
  
)

export default component.exports